import { Grid } from "@mui/material";
import { useState, useEffect, Fragment } from "react";

import { useAxios } from "../../hooks";
import { PageHeader, Pagination } from "../../components";
import BrandList from "./brand list components/BrandList";

export default function SuperAdminBrand() {
  const axios = useAxios();

  const [page, setPage] = useState({
    page: 1,
  });
  const [filterBy, setFilterBy] = useState("");
  const [loading, setLoading] = useState(true);
  const [brandList, setBrandList] = useState([]);
  const [searchBrands, setSearchBrands] = useState("");
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  useEffect(() => {
    setLoading(true);
    let url = `/getAllBrands?page=${page.page}&limit=10`;

    if (filterBy) {
      url = url + "&brand_type=" + filterBy;
    }

    if (searchBrands) {
      url = url + "&search=" + encodeURIComponent(searchBrands);
    }

    axios({
      url: url,
    }).then((response) => {
      if (response.status) {
        if (response.data.parsedBrands.length > 0) {
          setBrandList(response.data.parsedBrands);

          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: response.data.parsedBrands.length < 10,
          });
        } else {
          setBrandList(response.data);

          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: true,
          });
        }
      }
      setLoading(false);
    });
  }, [axios, filterBy, searchBrands, page.page]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"All Brands"}
            pageHeader={"View Users by brands"}
          />
        </Grid>
      </Grid>

      <BrandList
        setPage={setPage}
        setSearchKey={setSearchBrands}
        loading={loading}
        brandList={brandList}
        filterBy={filterBy}
        setFilterBy={setFilterBy}
        component={"users"}
      />

      {!!lastPage.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
